<template>
	<div class="container__crud">
		<div
			class="container__crudactions"
			style="border: 1px solid #a1a892; border-radius: 5px"
		>
			<div
				style="background-color: var(--color-green); border-radius: 3px 3px 0px 0px; height: 18px"
			>
				<br />
			</div>

			<div style="border-bottom: 1px solid #a1a892; border-radius-bottom: 10px">
				<h4 style="text-align: center; padding-top: 10px; margin-bottom: -10px; font-size: 18px">
					{{ $t('configColetaCubagem') }}
				</h4>
				<br />
			</div>

			<div style="padding: 10px 0px 20px 0px">
				<div class="container__crudactions__configuracoes">
					<div class="container__cruadaction__configuracoes__linha">
						<div style="margin-right: auto !important; margin-left: auto !important">
							<div
								style="
									border: 1px solid #a1a892;
									border-radius: 10px;
									padding: 5px 20px;
									margin-top: 10px;
								"
							>
								<h4 style="text-align: center; font-size: 16px">
									{{ $t('tipoDeMedicao') }}
								</h4>

								<RadioButtons
									v-model="model.config_app_tx_cbgm_tpmd"
									style="
										font-size: 16px;
										margin-top: 1rem;
										padding-right: auto;
										justify-content: center;
										display: flex;
									"
									group-name="valida-tmd"
									:options="optionsRadioButton"
								/>
							</div>
						</div>
						<div style="margin-left: auto !important; margin-right: auto !important">
							<div
								style="
									border: 1px solid #a1a892;
									border-radius: 10px;
									padding: 5px 20px;
									margin-top: 10px;
								"
							>
								<h4 style="text-align: center; font-size: 16px">
									{{ $t('numeroCasasDecimais') }}
								</h4>

								<RadioButtons
									v-model="model.config_app_nr_cbgm_nrcd"
									style="
										font-size: 16px;
										margin-top: 1rem;
										padding-right: auto;
										justify-content: center;
										display: flex;
									"
									group-name="valida-ncd"
									:options="optionsRadioButton2"
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<br />

		<div style="border: 1px solid #a1a892; border-radius: 5px">
			<div
				style="background-color: var(--color-green); border-radius: 3px 3px 0px 0px; height: 18px"
			>
				<br />
			</div>
			<div style="border-bottom: 1px solid #a1a892; border-radius-bottom: 10px">
				<h3 style="text-align: center; padding-top: 10px; margin-bottom: -10px; font-size: 18px">
					{{ $t('configInventarioFlorestal') }}
				</h3>
				<br />
			</div>
			<div style="padding-top: 10px">
				<div
					class="container__crudactions__configuracoes"
					style="margin: 10px 20px 20px 20px"
				>
					<div class="container__cruadaction__configuracoes__linha">
						<div style="margin-left: auto !important; margin-right: auto !important; width: 25%">
							<div
								style="
									border: 1px solid #a1a892;
									border-radius: 10px;
									padding: 5px 20px;
									margin-top: 10px;
								"
							>
								<h4 style="text-align: center; font-size: 16px">
									{{ $t('tipoDeMedicao') }}
								</h4>

								<RadioButtons
									v-model="model.config_app_tx_mdco_tpmd"
									style="
										font-size: 16px;
										margin-top: 1rem;
										padding-right: auto;
										justify-content: center;
										display: flex;
									"
									group-name="valida-tmd2"
									:options="optionsRadioButton"
								/>
							</div>
						</div>
						<div style="margin-left: auto !important; margin-right: auto !important; width: 25%">
							<div
								style="
									border: 1px solid #a1a892;
									border-radius: 10px;
									padding: 5px 20px;
									margin-top: 10px;
								"
							>
								<h4 style="text-align: center; font-size: 16px">
									{{ $t('retornarContagemArvores') }}
								</h4>

								<RadioButtons
									v-model="model.config_app_yn_mdco_arvs_count"
									style="
										font-size: 16px;
										margin-top: 1rem;
										padding-right: auto;
										justify-content: center;
										display: flex;
									"
									group-name="valida-n"
									:options="optionsRadioButton3"
								/>
							</div>
						</div>
						<div style="margin-left: auto !important; margin-right: auto !important; width: 25%">
							<div
								style="
									border: 1px solid #a1a892;
									border-radius: 10px;
									padding: 5px 20px;
									margin-top: 10px;
								"
							>
								<h4 style="text-align: center; font-size: 16px">
									{{ $t('numeroCasasDecimais') }}
								</h4>

								<RadioButtons
									v-model="model.config_app_nr_mdco_nrcd"
									style="
										font-size: 16px;
										margin-top: 1rem;
										padding-right: auto;
										justify-content: center;
										display: flex;
									"
									group-name="valida-ncd2"
									:options="optionsRadioButton2"
								/>
							</div>
						</div>
						<div style="margin-left: auto !important; margin-right: auto !important; width: 25%">
							<div
								style="
									border: 1px solid #a1a892;
									border-radius: 10px;
									padding: 5px 20px;
									margin-top: 10px;
									display: flex;
									flex-direction: column;
									justify-content: space-between;
								"
							>
								<h4 style="text-align: center; font-size: 16px">
									{{ $t('avaliacaoIntensidade') }}
								</h4>

								<RadioButtons
									v-model="model.config_app_tx_tipo_intensidade"
									style="
										font-size: 16px;
										margin-top: 1rem;
										padding-right: auto;
										justify-content: center;
										display: flex;
									"
									group-name="valida-intensidade"
									:options="optionsRadioButton5"
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
		<br />

		<div style="border: 1px solid #a1a892; border-radius: 5px">
			<div
				style="background-color: var(--color-green); border-radius: 3px 3px 0px 0px; height: 18px"
			>
				<br />
			</div>
			<div style="border-bottom: 1px solid #a1a892; border-radius-bottom: 10px">
				<h3 style="text-align: center; padding-top: 10px; margin-bottom: -10px; font-size: 18px">
					{{ $t('configuracaoColetaPilha') }}
				</h3>
				<br />
			</div>
			<div style="padding-top: 10px">
				<div
					class="container__crudactions__configuracoes"
					style="margin: 10px 20px 20px 20px"
				>
					<div class="container__cruadaction__configuracoes__linha">
						<div style="margin-right: auto !important; margin-left: auto !important">
							<div
								style="
									border: 1px solid #a1a892;
									border-radius: 10px;
									padding: 5px 20px;
									margin-top: 10px;
								"
							>
								<h4 style="text-align: center; font-size: 16px">
									{{ $t('tipoDeMedicao') }}
								</h4>

								<RadioButtons
									v-model="model.config_app_tx_pilha_tpmd"
									style="
										font-size: 16px;
										margin-top: 1rem;
										padding-right: auto;
										justify-content: center;
										display: flex;
									"
									group-name="valida-tmd3"
									:options="ooptionsRadioButton4"
								/>
							</div>
						</div>
						<div style="margin-left: auto !important; margin-right: auto !important">
							<div
								style="
									border: 1px solid #a1a892;
									border-radius: 10px;
									padding: 5px 20px;
									margin-top: 10px;
								"
							>
								<h4 style="text-align: center; font-size: 16px">
									{{ $t('numeroDiametrosObrigatorios') }}
								</h4>

								<RadioButtons
									v-model="model.config_app_nr_numero_de_diametros_obrigatorio"
									style="
										font-size: 16px;
										margin-top: 1rem;
										padding-right: auto;
										justify-content: center;
										display: flex;
									"
									group-name="valida-nmd"
									:options="optionsRadioButton2"
								/>
							</div>
						</div>
						<div style="margin-left: auto !important; margin-right: auto !important">
							<div
								style="
									border: 1px solid #a1a892;
									border-radius: 10px;
									padding: 5px 20px;
									margin-top: 10px;
								"
							>
								<h4 style="text-align: center; font-size: 16px">
									{{ $t('numeroCasasDecimais') }}
								</h4>

								<RadioButtons
									v-model="model.config_app_nr_numero_de_casas_decimais"
									style="
										font-size: 16px;
										margin-top: 1rem;
										padding-right: auto;
										justify-content: center;
										display: flex;
									"
									group-name="valida-ncd3"
									:options="optionsRadioButton2"
								/>
							</div>
						</div>
					</div>

					<div class="container__cruadaction__configuracoes__linha">
						<div style="margin-left: auto !important; margin-right: auto !important">
							<div
								style="
									border: 1px solid #a1a892;
									border-radius: 10px;
									padding: 5px 20px;
									margin-top: 10px;
								"
							>
								<h4 style="text-align: center; font-size: 16px">
									{{ $t('validacaoDeAltura') }}
								</h4>

								<InputText
									v-model="model.config_app_nr_altura_minima"
									:label="$t('minimoM')"
									placeholder="0,1 m"
									:mask="['#.#', '##.#', '###.#']"
								/>
								<InputText
									v-model="model.config_app_nr_altura_maxima"
									:label="$t('maximoM')"
									placeholder="3,0 m"
									:mask="['#.#', '##.#', '###.#']"
								/>
							</div>
						</div>

						<div style="margin-left: auto !important; margin-right: auto !important">
							<div
								style="
									border: 1px solid #a1a892;
									border-radius: 10px;
									padding: 5px 20px;
									margin-top: 10px;
								"
							>
								<h4 style="text-align: center; font-size: 16px">
									{{ $t('validacaoLargura') }}
								</h4>

								<InputText
									v-model="model.config_app_nr_largura_minima"
									:label="$t('minimoM')"
									placeholder="0,1 m"
									:mask="['#.#', '##.#', '###.#']"
								/>
								<InputText
									v-model="model.config_app_nr_largura_maxima"
									:label="$t('maximoM')"
									placeholder="3,0 m"
									:mask="['#.#', '##.#', '###.#']"
								/>
							</div>
						</div>

						<div style="margin-left: auto !important; margin-right: auto !important">
							<div
								style="
									border: 1px solid #a1a892;
									border-radius: 10px;
									padding: 5px 20px;
									margin-top: 10px;
								"
							>
								<h4 style="text-align: center; font-size: 16px">
									{{ $t('validacaoDiametro') }}
								</h4>

								<InputText
									v-model="model.config_app_diametro_minimo"
									:label="$t('minimoCM')"
									placeholder="0,1 cm"
									:mask="['#.#', '##.#', '###.#']"
								/>
								<InputText
									v-model="model.config_app_diametro_maximo"
									:label="$t('maximoCM')"
									placeholder="3,0 cm"
									:mask="['#.#', '##.#', '###.#']"
								/>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<br />
		<Button
			style="margin-left: auto; margin-right: 10px"
			:label="$t('salvar')"
			color="trv-default"
			semantic-class="tiny"
			width-auto
			@click="atualizarConfiguracao"
		/>
	</div>
</template>

<script>
import i18n from '../../../VueI18n'
import Button from '../../../components/Button/Button'
import InputText from '../../../components/InputText/InputText'
import RadioButtons from '../../../components/RadioButtons/RadioButtons'

import {
	atualizarConfiguracoesDoAplicativo,
	buscarConfiguracoesDoAplicativo,
} from '../../../services/requests/ConfiguracaoAplicativoRequests'

import { mapMutations } from 'vuex'

export default {
	components: {
		Button,
		InputText,
		RadioButtons,
	},
	methods: {
		...mapMutations({
			mutationShowMessage: 'moduleMessages/mutationShowMessage',
		}),
		atualizarConfiguracao() {
			const configuracao = {
				id: this.model.id,
				// Configuracoes cubagem
				config_app_nr_cbgm_nrcd: this.model.config_app_nr_cbgm_nrcd,
				config_app_tx_cbgm_tpmd: this.model.config_app_tx_cbgm_tpmd,

				// Configuracoes inventário traducional
				config_app_nr_mdco_nrcd: this.model.config_app_nr_mdco_nrcd,
				config_app_tx_mdco_tpmd: this.model.config_app_tx_mdco_tpmd,
				config_app_yn_mdco_arvs_count: this.model.config_app_yn_mdco_arvs_count,
				config_app_tx_tipo_intensidade: this.model.config_app_tx_tipo_intensidade,

				// Configuracoes de pilha
				config_app_tx_pilha_tpmd: this.model.config_app_tx_pilha_tpmd,
				config_app_nr_numero_de_diametros_obrigatorio:
					this.model.config_app_nr_numero_de_diametros_obrigatorio,
				config_app_nr_numero_de_casas_decimais: this.model.config_app_nr_numero_de_casas_decimais,
				config_app_nr_altura_minima: parseFloat(this.model.config_app_nr_altura_minima),
				config_app_nr_altura_maxima: parseFloat(this.model.config_app_nr_altura_maxima),
				config_app_nr_largura_minima: parseFloat(this.model.config_app_nr_largura_minima),
				config_app_nr_largura_maxima: parseFloat(this.model.config_app_nr_largura_maxima),
				config_app_diametro_minimo: parseFloat(this.model.config_app_diametro_minimo),
				config_app_diametro_maximo: parseFloat(this.model.config_app_diametro_maximo),
			}

			debugger
			atualizarConfiguracoesDoAplicativo(configuracao)
				.then((response) => {
					if (response.status === 200) {
						this.mutationShowMessage({
							messageTitle: this.$t('sucesso'),
							messageText: this.$t('configuracoesAtualizadas'),
							messageIcon: 'far fa-check-circle',
							messageType: 'success',
						})
					} else {
						this.mutationShowMessage({
							messageTitle: this.$t('erro'),
							messageIcon: 'far fa-check-circle',
							messageType: 'error',
						})
					}
				})
				.catch(() => {
					this.mutationShowMessage({
						messageTitle: this.$t('erro'),
						messageIcon: 'far fa-check-circle',
						messageType: 'error',
					})
				})
		},
	},
	data() {
		return {
			optionsRadioButton: [
				{ label: 'DAP', value: 'DAP' },
				{ label: 'CAP', value: 'CAP' },
			],
			optionsRadioButton2: [
				{ label: '1', value: 1 },
				{ label: '2', value: 2 },
			],
			optionsRadioButton3: [
				{ label: i18n.t('yes'), value: true },
				{ label: i18n.t('no'), value: false },
			],
			ooptionsRadioButton4: [
				{ label: i18n.t('diametro'), value: 'diametro' },
				{ label: i18n.t('circunferencia'), value: 'circunferencia' },
			],
			optionsRadioButton5: [
				{ label: i18n.t('continua'), value: 0 },
				{ label: i18n.t('categorizada'), value: 1 },
			],
			model: {
				id: '',
				// Configracao cubagem
				config_app_nr_cbgm_nrcd: 0,
				config_app_tx_cbgm_tpmd: '',

				// Configuracao inventario florestal
				config_app_nr_mdco_nrcd: 0,
				config_app_tx_mdco_tpmd: '',
				config_app_yn_mdco_arvs_count: undefined,
				config_app_tx_tipo_intensidade: undefined,

				// Configuracoes medicao de pilha
				config_app_tx_pilha_tpmd: '',
				config_app_nr_numero_de_diametros_obrigatorio: 0,
				config_app_nr_numero_de_casas_decimais: 0,
				config_app_nr_altura_minima: 0,
				config_app_nr_altura_maxima: 0,
				config_app_nr_largura_minima: 0,
				config_app_nr_largura_maxima: 0,
				config_app_diametro_minimo: 0,
				config_app_diametro_maximo: 0,
			},
		}
	},
	created() {
		buscarConfiguracoesDoAplicativo().then((response) => {
			const { result: configuracoes } = response.data

			this.model.id = configuracoes.id
			this.model.config_app_nr_cbgm_nrcd = configuracoes.config_app_nr_cbgm_nrcd
			this.model.config_app_nr_mdco_nrcd = configuracoes.config_app_nr_mdco_nrcd
			this.model.config_app_tx_cbgm_tpmd = configuracoes.config_app_tx_cbgm_tpmd
			this.model.config_app_tx_mdco_tpmd = configuracoes.config_app_tx_mdco_tpmd
			this.model.config_app_yn_mdco_arvs_count = configuracoes.config_app_yn_mdco_arvs_count
			this.model.config_app_tx_pilha_tpmd = configuracoes.config_app_tx_pilha_tpmd
			this.model.config_app_nr_numero_de_diametros_obrigatorio =
				configuracoes.config_app_nr_numero_de_diametros_obrigatorio
			this.model.config_app_nr_numero_de_casas_decimais =
				configuracoes.config_app_nr_numero_de_casas_decimais
			this.model.config_app_nr_altura_minima = configuracoes.config_app_nr_altura_minima.toFixed(1)
			this.model.config_app_nr_altura_maxima = configuracoes.config_app_nr_altura_maxima.toFixed(1)
			this.model.config_app_nr_largura_minima =
				configuracoes.config_app_nr_largura_minima.toFixed(1)
			this.model.config_app_nr_largura_maxima =
				configuracoes.config_app_nr_largura_maxima.toFixed(1)
			this.model.config_app_diametro_minimo = configuracoes.config_app_diametro_minimo.toFixed(1)
			this.model.config_app_diametro_maximo = configuracoes.config_app_diametro_maximo.toFixed(1)
			this.model.config_app_tx_tipo_intensidade = configuracoes.config_app_tx_tipo_intensidade
			debugger
		})
	},
}
</script>

<style scoped src="../../../css/crud.css"></style>

<style scoped>
.container__crudactions__configuracoes {
	display: flex;
	flex-direction: column;
}

.container__cruadaction__configuracoes__linha {
	display: flex;
	flex-direction: row;
	gap: 1rem;
	align-items: stretch;
}
</style>
